import React from 'react';

import { DefaultComponentProps } from '../../types';

import { CardHeader } from '../CardHeader';
import { CardBody } from '../CardBody';
import { CardFooter } from '../CardFooter';

interface Props extends DefaultComponentProps {
  tryToSubmitAgain: () => void;
}

export const UserCreateFailed = ({ textConfig, tryToSubmitAgain }: Props) => {
  const { title, ingress, emoji, emojiLabel, description } = textConfig.userCreateFailed;
  const { tryAgain } = textConfig.common;
  return (
    <>
      <CardHeader title={title} ingress={ingress} emoji={emoji} emojiLabel={emojiLabel} />
      <CardBody>
        <div className="card__card-body__description">{description}</div>
      </CardBody>
      <CardFooter>
        <button onClick={tryToSubmitAgain} type="button" id="wp-style-override" className="card__button card__button-filled">
          {tryAgain}
        </button>
      </CardFooter>
    </>
  );
};
